export enum DemoUserSetupStep {
  WELCOME = 'welcome',
  USER_FORM = 'user_form',
  CONFIRM_EMAIL = 'confirm_email',
}
